import {Component, OnInit, Output, Injectable} from '@angular/core';
import {LeadService} from '../services/lead.service';
import {Router, ActivatedRoute} from '@angular/router';
import {Headers, Http, Response, ResponseContentType} from '@angular/http';
import {FormControl, FormGroup} from '@angular/forms';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {EmitterService} from '../../housekeeping/services/emitter.service';
import {ExceldownloadService} from '../../housekeeping/services/exceldownload.service';
import {HttpClient, HttpResponse, HttpEventType} from '@angular/common/http';
import * as XLSX from 'xlsx';

import * as moment from 'moment';

@Injectable()
@Component({
  selector: 'app-lead-import',
  templateUrl: '../views/lead-import.component.html',
  styleUrls: ['../css/lead-import.component.css']
})
export class LeadImportComponent implements OnInit {
  public fileData: any;
  public uploadfilename = "";
  public showDivUpload: boolean = true;
  public showDivSuccess: boolean = false;
  public showDivError: boolean = false;
  public fileuploadedData = "";
  public inputData: any = [];
  public pushMaxRecords: boolean = true;
  public error_data: any;
  public upload_errorMessage = "";
  public upload_successMessage = "";
  public userId = localStorage.getItem("userId");
  public user = localStorage.getItem("roleId");
  public error_div: boolean = false;
  public partial_error_div: boolean = false;
  public totalRecords = 0;
  public insertedRecords = 0;
  public errorRecords = 0;
  public updatedRecords = 0;
  public hideReturn: boolean = false;

  constructor(public _leadService: LeadService, private http: Http, private _emitterService: EmitterService, private _exceldownloadService: ExceldownloadService) {
  }


  ngOnInit() {
    if (this.user == 'ADHVDR') {
      this.hideReturn = true;
    }
  }

  uploadBulkLeadData() {
    this._emitterService.setSpinner(true);
    let filenamexlsx = "eCKS_" + moment(new Date()).format("DDMMYYYY") + ".xlsx";
    let filenamexlx = "eCKS_" + moment(new Date()).format("DDMMYYYY") + ".xls";
    if (filenamexlsx == this.uploadfilename || filenamexlx == this.uploadfilename) {
      this._leadService.bulkFileUploadData(this.userId, this.fileuploadedData, (result) => {

        this._emitterService.setSpinner(false);
        this.totalRecords = result.count;
        if (result.updated != null)
          this.updatedRecords = result.updated;
        if (result.inserted != null)
          this.insertedRecords = result.inserted;

        if (result.erred != null && result.erred.count > 0) {
          this.partial_error_div = true;
          this.error_div = false;
          this.error_data = result.erred.records;
          this.errorRecords = result.erred.count;
          this.showDivUpload = false;
          this.showDivSuccess = false;
          this.showDivError = true;
        } else {
          this.upload_successMessage = "Success!  " + (this.insertedRecords + this.updatedRecords) + " number of records have been successfully loaded. The leads will be available to dealers within 2 hours";
          this.showDivUpload = false;
          this.showDivSuccess = true;
          this.showDivError = false;
        }
      });
    } else {
      this._emitterService.setSpinner(false);
      this.showDivUpload = false;
      this.showDivSuccess = false;
      this.showDivError = true;
      this.error_div = true;
      this.partial_error_div = false;
      this.upload_errorMessage = "Process Failed! The file is not in the correct format or the file name is incorrect. Please download the correct template by selecting the Download button and try again. The leads will not be loaded unless they are submitted in the correct format.";
    }
  }

  convertFile(csv: any) {
    this.fileuploadedData = csv.target.files;
    this.fileData = csv.target.files[0];
    this.uploadfilename = this.fileData.name

    /*let reader: FileReader = new FileReader();
    reader.readAsText(this.fileData);
    reader.onload = (e) => {
        let csv: string = reader.result;
        let allTextLines = csv.split(/\r|\n|\r/);
        let headers = allTextLines[0].split(',');
        let lines = [];
        console.log(allTextLines[0].length)
        for (let i = 0; i < allTextLines.length; i++) {
            // split content based on comma
            let data = allTextLines[i].split(',');
            if (data.length === headers.length) {
                let tarr = [];
                for (let j = 0; j < headers.length; j++) {
                    tarr.push(data[j]);
}
                // log each row to see output
                //console.log(JSON.stringify(tarr));
                lines.push(tarr);
            }
        }
    } */
  }

  showResultResponseDiv() {
    this.showDivUpload = true;
    this.showDivSuccess = false;
    this.showDivError = false;
    this.fileuploadedData = "";
    this.fileData = "";
    this.uploadfilename = "";
  }

  downloadErrorRecords() {
    const finalExportData = [];
    for (let i = 0; i < this.error_data.length; i++) {
      const filterfromloop = {
        'First_Name': this.error_data[i]['firstName'],
        'Last_Name': this.error_data[i]['lastName'],
        'Business_Name': this.error_data[i]['businessName'],
        'Email': this.error_data[i]['email'],
        'Address_1': this.error_data[i]['address1'],
        'Address_2': this.error_data[i]['address2'],
        'City': this.error_data[i]['city'],
        'State': this.error_data[i]['state'],
        'Country_Code': this.error_data[i]['countryCode'],
        'Postal_Code': this.error_data[i]['postalcode'],
        'Home_Phone': this.error_data[i]['homePhone'],
        'Work_Phone': this.error_data[i]['workPhone'],
        'Mobile_Phone': this.error_data[i]['mobilePhone'],
        'Global_Dealer_Code': this.error_data[i]['globalDealerCode'],
        'In Market_Time': this.error_data[i]['purchaseIntention'],
        'VOI_Make': this.error_data[i]['make'],
        'VOI_Model': this.error_data[i]['model'],
        'Call_to_Action_Description': this.error_data[i]['callToAction'],
        'Submission_Datetime': moment(this.error_data[i]['submissionDate']).format("YYYY-MM-DD HH:mm:ss"),
        'Event_ID': this.error_data[i]['eventId'],
        'Origin_Source_Description': this.error_data[i]['originSourceDescription'],
        'Showroom_Name': this.error_data[i]['showRoomName'],
        'Lead_Source': this.error_data[i]['leadSource'],
        'Reason': this.error_data[i]['errorMessages']
      };
      finalExportData.push(filterfromloop);
    }
    const fileName = "eCKS_" + moment(new Date()).format("DDMMYYYY");
    this._exceldownloadService.exportAsExcelFile(finalExportData, fileName)
  }

  /**
   * @author Pradeep
   * @description download template for lead bulk upload
   */

  downloadTemplate() {
    const finalExportData = [];

    const filterfromloop = {
      'First_Name': "",
      'Last_Name': "",
      'Business_Name': "",
      'Email': "",
      'Address_1': "",
      'Address_2': "",
      'City': "",
      'State': "",
      'Country_Code': "",
      'Postal_Code': "",
      'Home_Phone': "",
      'Work_Phone': "",
      'Mobile_Phone': "",
      'Global_Dealer_Code': "",
      'In Market_Time': "",
      'VOI_Make': "",
      'VOI_Model': "",
      'Call_to_Action_Description': "",
      'Submission_Datetime': "",
      'Event_ID': "",
      'Origin Source Description': "",
      'Showroom_Name': "",
      'Lead_Source': ""
    };
    finalExportData.push(filterfromloop);

    const fileName = "eCKS_" + moment(new Date()).format("DDMMYYYY");
    this._exceldownloadService.exportAsExcelFile(finalExportData, fileName)
  }

}




// WEBPACK FOOTER //
// ./src/app/modules/leads/components/lead-import.component.ts